import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Injectable } from "@angular/core";
import {Characteristics, ICharacteristics} from "../models/characteristics.model";
import {environment} from "../environments/environment";


@Injectable({
  providedIn: 'root'
})
export class CharacteristicsService{

  constructor(private http: HttpClient){}

  getCharacteristics() : Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/characteristic/allList`,{'headers': headers});
  }

  getAllCategories_v1(page: number, size: number, nameSearchText: string = ''): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));

    let url = `${environment.url}/characteristic/back/all?page=${page}&size=${size}`;
    if (nameSearchText) {
        url += `&nameSearchText=${encodeURIComponent(nameSearchText)}`;
    }

    return this.http.get<any>(url, { 'headers': headers });
  }

  query(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/characteristic` + (size ? '?page=' + page + '&size=' + size : ''));
  }

  getCharacteristicsBycurrentSearch(search: string, page: number, size: number){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/characteristic` + ('/_search?search=name:' + search +'&page=' + page + "&size=" + size),{'headers': headers});
  }

  getIdCharacteristics(idA:number)
  {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get(`${environment.url}/characteristic/`+idA,{'headers': headers});
  }
  saveCharacteristics(characteristics:ICharacteristics)
  {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.post<any>(`${environment.url}/characteristic`,characteristics,{'headers': headers});
  }

  updateCharacteristics(Characteristics:ICharacteristics){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.put<any>(`${environment.url}/characteristic/`+Characteristics.id,Characteristics, {'headers': headers});
  }

  deleteCharacteristics(idA:number){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.delete(`${environment.url}/characteristic/`+idA,{'headers': headers});
  }

  deleteListCharacteristics(ch: any[]) {
    let headers = new HttpHeaders().set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
  
    return this.http.request('DELETE', `${environment.url}/characteristic/list`, {
      headers: headers,
      body: ch
    });
  }
  
  
  getJobCharacteristic(){
    return this.http.get<any>(`${environment.url}/characteristic/job`);
  }

}
